import { useCallback } from "react";
import { useNavigate } from "react-router";

export const useNavigateTo = () => {
  const navigate = useNavigate();
  return useCallback(
    ({
      location,
      params,
      replace,
    }: {
      location?: string;
      params?: Record<string, string | null | undefined>;
      replace?: boolean;
    }) => {
      const currentParams = new URLSearchParams(window.location.search);

      Object.entries(params ?? {}).forEach(([name, value]) => {
        if (value != null) {
          currentParams.set(name, value);
        } else {
          currentParams.delete(name);
        }
      });

      void navigate(
        {
          pathname: location ?? window.location.pathname,
          search: currentParams.toString(),
        },
        { replace }
      );
    },
    [navigate]
  );
};
